import React, { Fragment, useState } from "react";
import styles from "./scss/chatEmpty.module.scss";
import tasksvg from "../../../../styles/images/tasksvg.svg";
import notessvg from "../../../../styles/images/notessvg.svg";
import eventsvg from "../../../../styles/images/eventsvg.svg";
import chatencrypt from "../../../../styles/images/chatencrypt.svg";
import { Modal, Select } from 'antd';
import { Link } from 'react-router-dom';
import URBroadCast from '../broadCast';
import store from "../../../../context/store/store";
import { chatSideWindow } from "../../../../base/eventService/eventApiService";
import { URButton } from "../../../../shared/widgets/button";
import { useSelector } from "react-redux";
import { contacts, initialStateModel, LoginState } from "../../../../models/model";
import { toastInformation, userStatusColor } from "../../../../base/callService/common";
import { useEffect } from "react";
import { compareName, Cookie, getcontactDetail, getTeamMembersnamelist } from "../../../../base/utils";
import { useRef } from "react";
import { SocketChatService } from "../../../../base/socketChatService";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import _ from 'lodash';
import { SearchAddMemberTeam } from "../../../../base/socketChatService/utils";

type memberListState = {
  contactList: Array<any>,
  searchMemberList: Array<any>,
  addedMember: Array<any>,
  isModalVisible: boolean,
  isremoveModal: boolean,
  removeMemberDetails: any,
  memberListArray: Array<any>,
  teamMemberList: Array<any>;

};
type profileState = {
  description: string;
  isGroupDescriptionModel: boolean;
  createdBy: any;
  isEdited: boolean;
};
export default function ChatEmpty() {
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  let { chatWindowReducer, contactReducer, loginReducer } = allReducer;
  let { userdetails }: LoginState = loginReducer;
  let { chatWindowDetails } = chatWindowReducer;
  const contactList: contacts = contactReducer;
  let adminValue:any = chatWindowDetails?.admin_members ? chatWindowDetails?.admin_members.split(",") : [];
  adminValue = adminValue.map((contactdata: any) => (contactdata.trim()));
  let memberList:any = chatWindowDetails?.team_members?.split(",");
  memberList = chatWindowDetails?.team_members && memberList.map((data: any, index: any) => data.trim());



  if (chatWindowDetails?.teammembersdetails) {
  let memberList = chatWindowDetails?.team_members?.split(",");
      memberList = memberList.map((data: any, index: any) => data.trim());
  var filterdList: any = Object.values(contactList?.workContactsnew);
  let list = chatWindowDetails.teammembersdetails;
  filterdList = _.filter(filterdList, function (o: any) { return !memberList.includes(o.sip_login_id.toString()); });
  
  var sortedList = filterdList.sort(compareName);
    if(list.includes(loginReducer.userdetails)){
      list =  list.filter((item:any) => item.sip_login_id !== loginReducer.userdetails.sip_login_id);
     list.unshift(loginReducer.userdetails);
    }
  }
  const [memberActions, setMemberActios] = useState<memberListState>({
    contactList: sortedList,
    searchMemberList: filterdList,
    addedMember: [], teamMemberList: [],
    isModalVisible: false, isremoveModal: false, removeMemberDetails: {}, memberListArray: []
  });

  const [profileDetails, setProfileDetails] = useState<profileState>({
    description: chatWindowDetails?.description,
    isGroupDescriptionModel: false, createdBy: {}, isEdited: false
  });
  const socketService = useRef<any>(null);
  useEffect(() => {
    const userInfo: any = Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if (userInfosess) {
      const cookieData = JSON.parse(userInfosess);
      socketService.current = new SocketChatService(cookieData?.sip_login_id, cookieData?.domain_id);
    }
    if (chatwindowDetails?.created_by) {
      let createdBydetails = getcontactDetail(chatwindowDetails?.created_by?.toString(), contactList?.workContactsnew, userdetails);
      setProfileDetails({ ...profileDetails, createdBy: createdBydetails });
    }

  }, [chatWindowDetails]);

  const openTask = (data: boolean) => {
    // if(memberList) chatSideWindow(data, "task", {});
  };

  const openNote = (data: boolean) => {
    // if(memberList) chatSideWindow(data, "notes", {});
  };

  const openEvent = (data: boolean) => {
    // if(memberList)chatSideWindow(data, "event", {});
  };


  const updateTextarea = (e: any) => {

    if (e.target.value.length > 100) {

      return true;
    }
    setProfileDetails({ ...profileDetails, description: e.target.value, isEdited: true });
  };

  const updateTeamDesc = async () => {
    let { description } = profileDetails;
    if (profileDetails.isGroupDescriptionModel && description.trim() === "") {
      return toastInformation("Enter Description", "failure");
    }
    else {

      let data = {
        companyId: chatWindowDetails.company_id,
        teamId: chatWindowDetails.team_id.toString(),
        sipId: chatWindowDetails.team_members,
        teamDescription: description
      };
      socketService.current.editGroupInfo(data);
    }

    setProfileDetails({ ...profileDetails, isGroupDescriptionModel: false, isEdited: false });
  };




  const addMemberCancel = () => {
    setMemberActios({ ...memberActions, isModalVisible: false, addedMember: [] });
  };
  const closeGroupDescModal = () => {
    setProfileDetails({ ...profileDetails, isGroupDescriptionModel: false });
  };
  const editDescription = () => {
    setProfileDetails({ ...profileDetails, isGroupDescriptionModel: true, description: chatWindowDetails.description });
  };
  const onChangeaddMembers = (values: any) => {

    setMemberActios({ ...memberActions, searchMemberList: memberActions?.contactList, addedMember: values });

  };

  const onSearchMembers = (value: any) => {

    let response = SearchAddMemberTeam(memberActions?.contactList, value.toLowerCase());
    setMemberActios({ ...memberActions, searchMemberList: response });
  };

  const addMembers = () => {
    setMemberActios({ ...memberActions, isModalVisible: true });
  };

  const addMembersToTeam = async () => {
    let addmemberdetails = {
      companyId: userdetails.company_id,
      teamId: chatWindowDetails?.team_id,
      teamMemberFromId:adminValue.includes(userdetails.sip_login_id) ? userdetails.sip_login_id : '',
      teamMemberSipId: memberActions?.addedMember.join()
    };
    socketService.current.addTeamMember(addmemberdetails);
    setMemberActios({ ...memberActions, isModalVisible: false, addedMember: [] });

  };

  let chatwindowDetails: any = store.getState().chatWindowReducer?.chatWindowDetails;
  return (
    <>
      {chatwindowDetails?.team_id ? <div className= {styles.chatEmpty}>

        <div className={`${styles.encryptedBox} ${styles.msgendcryptseccon}`}>
          <span className={styles.encryptedIcon}>
            <img src={chatencrypt} alt="" />
          </span>
          <span className={styles.encryptedText}>
            Messages are end-to-end encrypted. No one outside of this chat, not even Worktual, can read or listen to them. Click to learn more.
          </span>
        </div>
        <div className={styles.createdGroups}>
          <p>{`${profileDetails?.createdBy?.sip_login_id === userdetails?.sip_login_id ? `you` : profileDetails?.createdBy?.caller_id} created this Team. It’s private, and can only join by invitation`}</p>
        </div>
        {chatWindowDetails.team_type === 1 && <div className={styles.LogIconSec}>
          <span className="icon_lock"></span>
        </div>}
        <div className={styles.chatEmptyText}>
          This is the very early stage of the {chatwindowDetails?.team_name} Team
        </div>
        <div className={styles.NextGenCon}>
          {chatWindowDetails?.description && <p>{chatWindowDetails?.description}</p>}

        </div>
        <div className={styles.UserBadgeSecCon}>
          {chatwindowDetails?.teammembersdetails?.map((member: any,index:any) => (
            <Fragment key={index}>{member?.caller_id && <URBroadCast name={member} className='broadCastMessage' />}&nbsp;</Fragment>
          ))}


        </div>

        {adminValue?.includes(userdetails?.sip_login_id) &&  memberList.includes(loginReducer.userdetails.sip_login_id.toString().trim()) && 
        <div className={styles.linkConSection}>
          <Link to='#' onClick={editDescription}>Edit Description</Link>
          <Link to='#' onClick={addMembers}>Add Member</Link>
        </div>}
        <div className={styles.createNewList}>
          <div className={styles.tastList}>
            <div className={styles.boxSec} onClick={() => openTask(true)}>
              <img src={tasksvg} alt="" />
              {/* <span className={styles.textTitle}>Task</span> */}
            </div>
            <span className={styles.textDesc}>Create Tasks</span>
          </div>
          <div className={styles.tastList} onClick={() => openNote(true)}>
            <div className={styles.boxSec} >
              <img src={notessvg} alt="" />
              {/* <span className={styles.textTitle}>Notes</span> */}
            </div>
            <span className={styles.textDesc}>Create Notes</span>
          </div>
          <div className={styles.tastList} onClick={() => openEvent(true)}>
            <div className={styles.boxSec}>
              <img src={eventsvg} alt="" />
              {/* <span className={styles.textTitle}>Events</span> */}
            </div>
            <span className={styles.textDesc}>Create Events</span>
          </div>
        </div>
      </div> :
       <div className= {styles.chatEmpty} >
          <div className={`${styles.encryptedBox} ${styles.msgendcryptseccon} ${styles.chatdestype}`}>
            <span className={styles.encryptedIcon}>
              <img src={chatencrypt} alt="" />
            </span>
            <span className={styles.encryptedText}>
              Chats are end-to-end encrypted. Unless you`re in this chat, no one - not even Worktual - can read.
            </span>
          </div>
          <div className={styles.chatEmptyText}>
            “You`ve not chatted on Worktual with {chatwindowDetails?.caller_id} before.
           Exciting! We`ve got some features we suggest using to ease them in.”
          </div>
          {/* <div className={styles.createNewList}>
            <div className={styles.tastList}>
              <div className={styles.boxSec} onClick={() => openTask(true)}>
                <img src={tasksvg} alt="" />
               
              </div>
              <span className={styles.textDesc}>Assign Task</span>
            </div>
            <div className={styles.tastList} onClick={() => openNote(true)}>
              <div className={styles.boxSec} >
                <img src={notessvg} alt="" />
                
              </div>
              <span className={styles.textDesc}>Write Note</span>
            </div>
            <div className={styles.tastList} onClick={() => openEvent(true)}>
              <div className={styles.boxSec}>
                <img src={eventsvg} alt="" />
                
              </div>
              <span className={styles.textDesc}>Create Event</span>
            </div>
          </div> */}
        </div>}
     {memberActions.isModalVisible && <Modal visible={memberActions.isModalVisible} className={`${styles.addmembermodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={addMemberCancel} />
        <h2>Add Team Member</h2>
        <p><span className="icon_lock"></span>{chatWindowDetails?.team_name}</p>
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Search a user name or extension number"
          className="newselects"
          dropdownClassName="newChatSel"
          value={memberActions.addedMember}
          onChange={(e: any) => onChangeaddMembers(e)} onSearch={onSearchMembers} showSearch={true}
          filterOption={false}>
          {memberActions?.searchMemberList.map((contact: any, index: number) => {

            return (<option value={contact.sip_login_id} key={index}>
              <div className="dropdowndesign">


                <div className="usergroupss">
                  <URAvatarGroup className='lefts size20' profileInfo={<>
                    {contact.ImageURL ?
                      <img src={contact.ImageURL} alt="" /> :
                      <span>{contact.caller_id?.charAt(0)}</span>}
                    <URStatusDot
                      className={userStatusColor(contact?.user_status, 'small')} />
                  </>} />
                </div>
                <div className="names">{contact.caller_id}</div>
                <div className="ext">{contact.ext}</div>
              </div>
            </option>);
          })}


        </Select>
        <div className={styles.footersection}>
          <URButton className='urButton buttonWhite buttonMd mr8' name="Cancel" onClick={addMemberCancel}></URButton>
          <URButton className='urButton buttonBlue buttonMd' onClick={addMembersToTeam} disabled={memberActions.addedMember.length === 0 && memberActions.addedMember.length === 0 ? true : false} name="Add"></URButton>
        </div>
      </Modal> }
    {profileDetails.isGroupDescriptionModel &&  <Modal visible={profileDetails.isGroupDescriptionModel}
        className={`${styles.editprofilename} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={closeGroupDescModal} />
        <h2>Edit Team Description</h2>
        <textarea name="" placeholder="Enter description" maxLength={100} rows={3}
          className="editprofilename textareasnew" value={profileDetails?.description}
          onChange={updateTextarea}></textarea>
        <p className={styles.valueinput}>{profileDetails?.description && profileDetails?.description?.length}</p>
        <div className={styles.footersection}>
          <URButton className={styles.cancelbtn} onClick={closeGroupDescModal} name="Cancel"></URButton>
          <URButton className={styles.savebtn} disabled={profileDetails.isEdited ? false : true}
            onClick={updateTeamDesc} name="Save"></URButton>
        </div>
      </Modal> }
    </>
  );
};

